import axios from "axios";
import qs from 'qs';
import {
    Toast,
} from 'vant';

axios.defaults.timeout = 10 * 1000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://new2.h5no1.com/dBCURD/api/utils/' : 'api/';

//传cookie
axios.defaults.withCredentials = true;

//POST传参序列化
axios.interceptors.request.use((config) => {

    if (config.method === 'post') {
        config.data = qs.stringify(config.data);
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {

    return response;
}, (err) => {
    Toast("网络异常，稍后重试");
    console.log(err)
});

export default {

    getOssInfo(){
        const instance = axios.create({
            baseURL: 'https://new2.h5no1.com/dBCURD/api', // 能用 https 的情况下，请使用 https
            timeout: 10 * 1000
        });
        return instance.get('/utils/tools/oss_token2');
    },

}
